import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../emotion-theme";

export const ReadonlyField = styled.div`
  padding: 16px 0 8px 0;
  color: rgba(0, 0, 0, 0.95);
  font-weight: 400;
  font-size: 12px;
  font-family: Lato;
`;

export const ReadonlyFieldLabel = styled.div`
  color: ${BASE_COLORS.grey};
  padding: 0 0 4px 0;
`;
